import {Currency, PaymentFormFields, Price} from '@focusritegroup/web-ui';
import {User} from '@focusrite-novation/ampify-api';
import {UseCheckoutPricingState} from '@recurly/react-recurly';

export interface RecurlyToken {
  id: string;
  type: string;
}

export interface CardSubscriptionRequestBody {
  planId: string;
  token: string;
  currency: string;
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
  address: {
    street1: string;
    street2: string;
    city: string;
    country: string;
    region: string;
    postalCode: string;
  };
  couponCode?: string;
  threeDSecureActionResultTokenId?: string;
}

export const createCardSubscriptionRequestBody = (
  values: PaymentFormFields,
  planId: string,
  user: User,
  currency: Currency,
  token: string
): CardSubscriptionRequestBody => ({
  planId,
  token,
  email: values.email?.trim(),
  currency,
  userId: user.id as number,
  firstName: values.firstName,
  lastName: values.lastName,
  address: {
    street1: values.street,
    street2: values.street2,
    city: values.city,
    country: values.country,
    region: values.region,
    postalCode: values.postalCode,
  },
  couponCode: values.couponCode,
});

export interface CouponSubscriptionRequestBody {
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
  couponCode: string;
  planId: string;
}

export const createCouponSubscriptionRequestBody = (
  {email, firstName, lastName, couponCode}: PaymentFormFields,
  planId: string,
  user: User
): CouponSubscriptionRequestBody => ({
  userId: user.id as number,
  email,
  firstName,
  lastName,
  couponCode: couponCode ? couponCode.trim() : '',
  planId,
});

export const getPrice = (
  priceState: UseCheckoutPricingState,
  useCoupon: boolean,
  billingDuration: string
): Price | undefined => {
  const hasPrice = !priceState.loading && priceState.price.next;

  return hasPrice
    ? {
        currencySymbol: priceState.price.currency.symbol,
        total: `${priceState.price.next.total}/${billingDuration} `,
        taxInclusive: useCoupon ? true : priceState.price.taxes.length > 0,
      }
    : undefined;
};

export type SubscriptionRequestBody =
  | CouponSubscriptionRequestBody
  | CardSubscriptionRequestBody;
